import { BotIcon } from "./assets";
import ProjectGovernorDisplay from "./projectGovernor/ProjectGovernorDisplay";
import ProjectGovernorForm from "./projectGovernor/ProjectGovernorForm";
import TeradataToSnowflakeMigratorDisplay from "./teradata/MigratorDisplay";
import { TaskLabels, TeamMateAvailability, TeamMateConfig } from "./types";
import AlertManagerDisplay from "./alertManager/AlertManagerDisplay";

export const TeamMatesConfig: TeamMateConfig[] = [
  {
    name: "Write Documents",
    avatar: BotIcon,
    description:
      "Coach AI to write your dbt model, table and column descriptions for you, like you!",
    availability: [TeamMateAvailability.EXTENSION],
    key: TaskLabels.DocGen,
  },
  {
    name: "Chart Analyzer",
    avatar: BotIcon,
    description: "Coach AI to analyze charts, find insights and answer your specific questions",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.ChartBot,
    seeInAction: false,
  },
  {
    name: "Translate SQL dialects",
    avatar: BotIcon,
    description: "Coach AI  to translate or explain SQL queries in other dialects",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.SqlBot,
  },
  {
    name: "Govern dbt Projects",
    avatar: BotIcon,
    description: "Coach AI to help you create checks or rules for project governance config",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.ProjectGovernor,
    displayComponent: ProjectGovernorDisplay,
    formComponent: ProjectGovernorForm,
  },
  {
    name: "Save Snowflake Costs",
    avatar: BotIcon,
    description: "Coach AI to analyze your spends, costs and find opportunities to save money",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.OpportunitiesBot,
    comingSoon: true,
  },
  {
    name: "Migrate Teradata to Snowflake",
    avatar: BotIcon,
    description: "Coach AI to streamline your database migration journey",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.TeradataToSnowflakeMigrator,
    displayComponent: TeradataToSnowflakeMigratorDisplay,
    comingSoon: () => new URLSearchParams(window.location.search).get("tsm") !== "1",
  },
  {
    name: "Setup Alerts",
    avatar: BotIcon,
    description: "Coach AI to manage your alerts and notifications",
    availability: [TeamMateAvailability.SAAS],
    key: TaskLabels.AlertManager,
    displayComponent: AlertManagerDisplay,
    comingSoon: false,
  },
];
